import axios from 'axios';
import { POST_HOUSE_ENTRANCE_COORDINATE_API_URL, POST_HOUSE_ENTRANCE_COORDINATE_MANUALLY_API_URL,
  DELETE_HOUSE_API_URL } from '../OpticApiConfig';


    // Запись координат подъездов в MapsHouseEntranceCoordinates
    export const WriteHouseEntranceCoordinate = async (markers, showSnackbar, entrances, houseId, searchAddress ) => {
        const entranceNumbers = markers.map(marker => marker.entrance);
        const hasDuplicates = entranceNumbers.some((item, index) => entranceNumbers.indexOf(item) !== index);
    
        if (hasDuplicates) {    
          showSnackbar('Обнаружены повторяющиеся номера подъездов!', 'snackbarWarning');
        }else if(markers.length != entrances){
          showSnackbar('Количество маркеров не соответствует количеству подъездов!', 'snackbarWarning');
        }else {
          try {
            const token = localStorage.getItem('token');
            const response =  await axios.post(`${POST_HOUSE_ENTRANCE_COORDINATE_API_URL}`, {
              houseId,
              markers
            }, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
              }
            });
      
            if (response.status === 200) {
              showSnackbar('Данные успешно сохранены!', 'snackbarSuccess');
              searchAddress();
            } else {
              showSnackbar('Ошибка при сохранении данных!', 'snackbarError');
            }
          } catch (error) {
            showSnackbar('Ошибка при отправке данных на сервер!', 'snackbarError');
          }
        }
      };

    // Запись координат подъездов в ручном режиме MapsHouseEntranceCoordinates
    export const WriteHousesEntranceCoordinate = async (markers, houseId, entrances, showSnackbar, searchAddress) => {    
      const entranceNumbers = markers.map(marker => marker.entrance);
      const hasDuplicates = entranceNumbers.some((item, index) => entranceNumbers.indexOf(item) !== index);
    
      if (hasDuplicates) {
        showSnackbar('Обнаружены повторяющиеся номера подъездов!', 'snackbarWarning');
      } else if (markers.length !== entrances) {
        showSnackbar('Количество маркеров не соответствует количеству подъездов!', 'snackbarWarning');
      } else {
        try {
          const token = localStorage.getItem('token');
          
          const formattedMarkers = markers.map(marker => ({
            entrance: marker.entrance,
            position: {
              lat: marker.position?.lat || marker.lat,  // Используйте существующее значение lat
              lng: marker.position?.lng || marker.lng   // Используйте существующее значение lng
            }
          }));
          
          // Отправка отформатированных данных на сервер
          const response = await axios.post(POST_HOUSE_ENTRANCE_COORDINATE_MANUALLY_API_URL, {
            houseId,
            markers: formattedMarkers
          }, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });
    
          // Обработка ответа сервера
          if (response.status === 200) {
            showSnackbar(response.data.message, 'snackbarWarning');
            searchAddress();
           // console.log(response.data);
          } else {
           // console.error(response.data);
            showSnackbar(response.data.message, 'snackbarWarning');
          }
    
        } catch (error) {
          showSnackbar('Ошибка при отправке данных на сервер!', 'snackbarWarning');
        }
      }
    };

  // Удаление координат дома
export const DeleteHousesEntranceCoordinate = async (houseId, showSnackbar, searchAddress) => {
  try {
    const token = localStorage.getItem('token');

    // Отправка запроса на сервер
    const response = await axios.delete(`${DELETE_HOUSE_API_URL}${houseId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    // Обработка ответа сервера
    if (response.status === 200) {
      showSnackbar(response.data, 'snackbarWarning');
      searchAddress();
    } else {
      showSnackbar(response.data, 'snackbarWarning');
    }

  } catch (error) {
    showSnackbar('Ошибка при отправке данных на сервер!', 'snackbarWarning');
  }
};

